@if (disableRadioButtons) {
  <div>
    <div class="flex gap-2">
      <p class="font-semibold shrink-0">Account Type:</p>
      <span>  Health Plan Case Manager</span>
    </div>
  </div>
}
@if (!disableRadioButtons) {
  <div class="flex gap-4 py-2">
    <div class="font-semibold w-21 shrink-0">Account Type:</div>

    @if (!removeCHAPPAccountType) {
      <form [formGroup]="accountSwitchForm" class="flex gap-4 flex-wrap">
        @for (type of availableAccountTypes; track type) {
          <div>
            <p-radio-button
              name="accountTypeControl"
              formControlName="accountTypeControl"
              class="pb-2"
              [inputId]="type.value"
              [value]="type.value"
              [accessFormField]="['ExternalUser.Write']"
              (onClick)="accountTypeChange($event)"
            />
            <label [for]="type.value" class="ml-2">{{ type.label }}</label>
          </div>
        }
      </form>
    }
    @if (removeCHAPPAccountType) {
      <p class="ml-4">{{ this.chappProviderAccountType }}</p>
    }
  </div>
}
<p-toast key="warn" position="bottom-left" />
<p-toast key="switched" position="bottom-left" />
<p-dialog
  header="Update Account Type"
  [(visible)]="showDialog"
  [modal]="true"
  appendTo="body"
  [closable]="false"
  [resizable]="false"
  [ngStyle]="{'width': '400px'}"
  [minY]="70"
  [maximizable]="false"
>
  <p>Are you sure that you want to update the Account Type?</p>
  <ng-template #footer>
    <button pButton (click)="proceedUpdate()">Yes</button>
    <button pButton severity="secondary" (click)="cancelUpdate()">No</button>
  </ng-template>
</p-dialog>
